import { render, staticRenderFns } from "./shopCoopEdit.vue?vue&type=template&id=3cce0324&scoped=true&"
import script from "./shopCoopEdit.vue?vue&type=script&lang=js&"
export * from "./shopCoopEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cce0324",
  null
  
)

export default component.exports